import React, { useMemo } from 'react';
import { Link } from 'gatsby';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Typography } from '../../../atoms/typography/Typography';
import { ArrowFull } from '../../../../../static/icons/arrowFull';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import colors from '../../../../../tailwind.colors';
import { buttonBackgroundClasses } from '../../../atoms/button/buttonColors';

// const getRandomColor = () => {
//   const bgColors = [
//     'bg-primary-800',
//     'bg-primary-500',
//     'bg-primary-400',
//     'bg-secondary-600',
//     'bg-secondary-400',
//     'bg-secondary-300',
//   ];
//   const randomIndex = Math.floor(Math.random() * bgColors.length);
//   return bgColors[randomIndex];
// };

const getLinkButtons = (linkButtons) =>
  linkButtons?.map((button, i) => ({
    name: button.name,
    url: button.url,
    color: buttonBackgroundClasses[i % buttonBackgroundClasses.length],
  }));

const PopularCategories = ({
  section,
  showTitles = true,
  t,
  showAllCategoriesLink = true,
}) => {
  const linkButtons = useMemo(
    () => getLinkButtons(section?.componentData),
    [section]
  );

  return (
    <Stack className="px-8 mx-auto my-24 max-w-5xl gap-10">
      {showTitles && section?.title && (
        <Typography fontVariant="h4" as="h2">
          {section.title}
        </Typography>
      )}
      <div className="flex flex-wrap gap-1 justify-center">
        {linkButtons?.map((category) => (
          <LinkButton
            key={category.url}
            href={category.url}
            size="lg"
            className={`m-1 ${category.color} font-bold`}
            label={category.name}
          />
        ))}
      </div>
      {showAllCategoriesLink && (
        <Row className="w-fit global-hover self-center items-center py-2">
          <Link
            to={section.linkUrl}
            className="flex flex-row gap-1 w-fit global-hover self-center items-center py-2 text-clamp-h8 font-medium !text-primary-700"
          >
            {t('common.allCategories')}
            <ArrowFull color={colors.primary[700]} direction="right" />
          </Link>
        </Row>
      )}
    </Stack>
  );
};

export default PopularCategories;
